var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import ___default from "lodash";
import { getDefaultFeatureMetadata, getInitialFlightList, getDefaultFlight, getDefaultFlightForControl } from "@ane/exp-data/lib/defaultData/FeatureInitialData";
import { generateNewFlightName, generateRandomFlightName } from "@ane/exp-data/lib/utils/FlightUtils";
import { parse } from "query-string";
import { parseFeatureInfo, parseAssignmentUnitSelection } from "@ane/exp-data/lib/utils/FeatureUtils";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import { featureUtilsV2Instance } from "@ane/exp-data/lib/utils/FeatureUtilsV2";
import operationCheckUtils from "@ane/exp-data/lib/utils/OperationCheckUtils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { fromAssignmentUnitsV2 } from "@ane/exp-data/lib/utils/AssignmentUnitUtils";
import { fromIsolationGroupsV2 } from "@ane/exp-data/lib/utils/IsolationGroupUtils";
import { DefaultTreatmentVariableNamespace } from "../constants/module.constants.js";
const getTreatmentVariableDefaultNamespace = (flightControl) => {
  var _a;
  let treatmentVariableNamespace = DefaultTreatmentVariableNamespace;
  if (((_a = flightControl == null ? void 0 : flightControl.TreatmentVariableNamespaces) == null ? void 0 : _a.length) > 0)
    treatmentVariableNamespace = flightControl == null ? void 0 : flightControl.TreatmentVariableNamespaces[0];
  else if ((flightControl == null ? void 0 : flightControl.TreatmentVariableNamespace) != null)
    treatmentVariableNamespace = flightControl.TreatmentVariableNamespace;
  return treatmentVariableNamespace;
};
const parseFeatureInner = (input) => {
  var _a, _b, _c;
  const {
    feature,
    flightControl,
    ctExperience,
    isAuthorized,
    operationCheckAsync,
    workspaceId,
    managementGroup,
    queryParams = parse(document.location.search),
    isolationGroups = [],
    assignmentUnits = [],
    showVNextProgressionPage
  } = input;
  let featureMetadata = __spreadProps(__spreadValues({}, getDefaultFeatureMetadata()), { workspaceId, managementGroup });
  let flightList = getInitialFlightList();
  const overrideAlias = queryParams.User || queryParams.user;
  const userHasWritePermission = !overrideAlias && isAuthorized;
  const progressionsVariables = ctExperience == null ? void 0 : ctExperience.Progressions;
  const IsControlFlightNameEditable = EnvironmentService.isUnifiedView || (flightControl == null ? void 0 : flightControl.IsControlFlightNameEditable) || false;
  const treatmentVariableEnabled = (flightControl == null ? void 0 : flightControl.EnableTreatmentVariables) || false;
  const isControlEnabled = (flightControl == null ? void 0 : flightControl.DefaultControlsEnabledValue) !== false;
  featureMetadata.userHasWritePermission = userHasWritePermission;
  featureMetadata.showVNextProgressionPage = !!showVNextProgressionPage;
  if (!!feature) {
    const parsedData = parseFeatureInfo(feature, IsControlFlightNameEditable, userHasWritePermission || false);
    featureMetadata = __spreadProps(__spreadValues(__spreadValues({}, featureMetadata), parsedData.featureMetadata), {
      workspaceId: feature.WorkspaceId,
      managementGroup: feature.ManagementGroup
    });
    flightList = __spreadValues(__spreadValues({}, flightList), parsedData.flightList);
  } else {
    let flights = [];
    if (IsControlFlightNameEditable) {
      const defaultFlight = getDefaultFlight([], treatmentVariableEnabled, isControlEnabled);
      defaultFlight.name = generateNewFlightName(generateRandomFlightName(3), generateRandomFlightName(5));
      const defaultControlFlight = getDefaultFlightForControl([], treatmentVariableEnabled, isControlEnabled);
      defaultControlFlight.name = generateNewFlightName(generateRandomFlightName(3), generateRandomFlightName(5));
      flights = [defaultFlight, defaultControlFlight];
    } else {
      const defaultFlight = getDefaultFlight([], treatmentVariableEnabled, isControlEnabled);
      flights = [defaultFlight];
    }
    flightList = { flights, explicitControlFlights: IsControlFlightNameEditable };
  }
  featureMetadata.id = (_a = featureMetadata.id) != null ? _a : "";
  featureMetadata.operationCheck = operationCheckUtils.parseOperationCheckResponse(
    {
      operationChecks: (operationCheckAsync == null ? void 0 : operationCheckAsync.data) || null,
      error: (operationCheckAsync == null ? void 0 : operationCheckAsync.error) || null,
      errorDetails: (operationCheckAsync == null ? void 0 : operationCheckAsync.errorContext) || null
    },
    featureMetadata.operationCheck
  );
  featureMetadata.owners = !!feature ? featureMetadata.owners : (flightControl == null ? void 0 : flightControl.DefaultOwners) || [];
  featureMetadata.treatmentVariableEnabled = treatmentVariableEnabled;
  featureMetadata.treatmentVariableNamespace = flightControl == null ? void 0 : flightControl.TreatmentVariableNamespace;
  featureMetadata.treatmentVariableNamespaces = flightControl == null ? void 0 : flightControl.TreatmentVariableNamespaces;
  featureMetadata.treatmentVariableDefaultNamespace = getTreatmentVariableDefaultNamespace(flightControl);
  featureMetadata.treatmentVariableNamespacePrefix = flightControl == null ? void 0 : flightControl.TreatmentVariableDisplayPrefix;
  featureMetadata.isControlEnabledDefault = isControlEnabled;
  featureMetadata.canDisableControlFlight = (flightControl == null ? void 0 : flightControl.CanDisableControlFlight) || false;
  featureMetadata.assignmentUnits = showVNextProgressionPage ? fromAssignmentUnitsV2(assignmentUnits) : parseAssignmentUnitSelection(flightControl == null ? void 0 : flightControl.AssignmentUnitSelection);
  featureMetadata.canRestartProgressionStage = progressionsVariables ? !!(progressionsVariables == null ? void 0 : progressionsVariables.CanRestartProgressionStage) : false;
  featureMetadata.enableOverrideTargets = showVNextProgressionPage ? false : (flightControl == null ? void 0 : flightControl.EnableOverrideTargets) || false;
  featureMetadata.enableEmergencyShutdown = (ctExperience == null ? void 0 : ctExperience.EnableEmergencyShutdown) || false;
  featureMetadata.enableSubscriptionSelection = (ctExperience == null ? void 0 : ctExperience.EnableSubscriptionSelection) || false;
  featureMetadata.subscriptionOptions = (flightControl == null ? void 0 : flightControl.Subscriptions) || [];
  featureMetadata.defaultSubscriptions = (flightControl == null ? void 0 : flightControl.Partners) || [];
  featureMetadata.isFlightCountersEnabled = (flightControl == null ? void 0 : flightControl.IsFlightCountersEnabled) || false;
  featureMetadata.enableComboFlight = (ctExperience == null ? void 0 : ctExperience.EnableComboFlight) || false;
  featureMetadata.flightNameLengthReservedBySystem = (_b = flightControl == null ? void 0 : flightControl.FlightNameLengthReservedBySystem) != null ? _b : MasterDataConstants.flightLengthReservedBySystemDefault;
  featureMetadata.maxFlightNameLength = (_c = flightControl == null ? void 0 : flightControl.MaxFlightNameLength) != null ? _c : MasterDataConstants.maxFlightNameLengthDefault;
  featureMetadata.enableIsolationGroupSelection = EnvironmentService.isUnifiedView ? true : (ctExperience == null ? void 0 : ctExperience.EnableIsolationGroupSelection) || false;
  featureMetadata.isolationGroupOptions = showVNextProgressionPage ? fromIsolationGroupsV2(isolationGroups) : (flightControl == null ? void 0 : flightControl.IsolationGroupsOwned) || [];
  featureMetadata.isAutoGeneratedIsolationGroup = showVNextProgressionPage && !isolationGroups.some((ig) => ig.isUserManaged) || featureUtilsV2Instance.isAutoGeneratedIsolationGroup(
    featureMetadata.isolationGroups,
    featureMetadata.autoGeneratedIsolationGroup
  );
  flightList.explicitControlFlights = IsControlFlightNameEditable;
  flightList.flights.forEach((f) => {
    f.isCreated = !!feature;
  });
  return { featureMetadata, flightList };
};
let cachedInput = null;
let cachedResponse = null;
const parseFeature = (input) => {
  if (!___default.isEqual(input, cachedInput)) {
    console.log("parsed feature");
    cachedInput = ___default.cloneDeep(input);
    const response = parseFeatureInner(input);
    cachedResponse = ___default.cloneDeep(response);
    return response;
  } else {
    console.log("returned cached");
    return cachedResponse;
  }
};
export {
  parseFeature,
  parseFeatureInner
};
//# sourceMappingURL=FeatureParser.js.map
